<template>
    <div>
        <div class="form-group">
            <label>{{translate('ozne.gercekSahis.identityNumber')}}</label>
            <input v-model="value.TcKimlikNo" type="tel" maxlength="11" class="form-control" />
        </div>
        <div class="form-group">
            <label>{{translate('ozne.gercekSahis.name')}}</label>
            <input v-model="value.Ad" type="text" maxlength="30" class="form-control" required />
        </div>
        <div class="form-group">
            <label>{{translate('ozne.gercekSahis.secondName')}}</label>
            <input v-model="value.IkinciAd" type="text" maxlength="30" class="form-control" />
        </div>
        <div class="form-group">
            <label>{{translate('ozne.gercekSahis.surname')}}</label>
            <input v-model="value.Soyad" type="text" maxlength="30" class="form-control" required />
        </div>
        <div class="form-group">
            <label>{{translate('ozne.gercekSahis.unvan')}}</label>
            <input v-model="value.Unvan" type="text" maxlength="100" class="form-control" />
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {

    }
}

</script>
